import React, { useContext } from 'react';

import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { BudgetModal } from '@atom/types/budget';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import {
  Environment,
  isCurrentEnvironment,
} from '@atom/utilities/featureToggleUtilities';

import BudgetsContext from './BudgetsContext';

import './budgets.css';

const styles = {
  blueButton: {
    backgroundColor: colors.brand.blue,
    color: colors.neutral.white,
    padding: '0.5rem 1rem',
  },
  text: {
    fontSize: '1rem',
  },
  icon: {
    fontSize: '3rem',
    color: colors.neutral.silver,
  },
};

const BudgetsNoneAvailable = () => {
  const { setActiveModal } = useContext(BudgetsContext);

  /*
    TODO: Replace temporary permissions here with RBAC
    
    Current Rules:
    QA and Production:
    - Create button is hidden for everyone except Admin for all budgets
    Dev and UAT:
    - Create button is hidden for everyone below Org Admin (show for Admin and Org Admin)
  
    source: https://atomai.atlassian.net/browse/AM-15294
  */
  const roleNeeded: string[] = isCurrentEnvironment([
    Environment.QA,
    Environment.PRODUCTION,
  ])
    ? ROLE_SETS.ADMIN
    : ROLE_SETS.ORG_ADMIN;
  const canAddBudgets: boolean = hasRolePermissions(roleNeeded);

  return (
    <div styleName="container-no-budgets">
      <Icon style={styles.icon}>insert_chart_outlined</Icon>
      <span style={styles.text}>No Budget Found</span>
      {canAddBudgets && (
        <Button
          style={styles.blueButton}
          onClick={() => setActiveModal(BudgetModal.CREATE)}
          startIcon={<Icon color={colors.neutral.white}>add</Icon>}
          data-cy="dashboardEmptyCustomizeIcon"
        >
          CREATE A BUDGET
        </Button>
      )}
    </div>
  );
};

export default BudgetsNoneAvailable;
